import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../../services/remote/auth.service';
import { CompanyService } from '../../../../services/remote/company.service';
import { User } from '../../../../types/user';

@Component({
  selector: 'cognos-header',
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  public loggedUser: User | null = null;

  constructor(
    private _authService: AuthService,
    private _companyService: CompanyService
  ) {}

  ngOnInit(): void {
    this.loggedUser = this._authService.getUserFromLocalStorage();
    this._companyService.fetchCompanies();
  }

  public logout = () => {
    this._authService.logout();
  };
}
